module.exports = __webpack_public_path__ + "static/image-7a6c9fd6f105437d1a87dbde7b3565f0.jpg";